import React from 'react';
import classnames from 'classnames';
import { useUniqueId } from '@wix/da-a11y/pkg/hooks/useUniqueId';
import s from './LiteratureCoverLetter.scss';
var LiteratureCoverLetter = function (_a) {
    var className = _a.className, title = _a.title, isBigEnough = _a.isBigEnough, _b = _a.alignment, alignment = _b === void 0 ? 'end' : _b;
    var gradientId = useUniqueId();
    var filteredTitle = title && title.replace(/[^a-zA-Z]/g, '');
    if (!filteredTitle || !filteredTitle.length) {
        return null;
    }
    return (React.createElement("div", { className: classnames(s['root'], !isBigEnough && s['letter-scale'], s[alignment], className), "aria-hidden": "true" },
        React.createElement("svg", { height: "100%", viewBox: "0 0 15 12", preserveAspectRatio: "xMidYMin slice", fillRule: "evenodd" },
            React.createElement("linearGradient", { x1: "87.8481761%", y1: "16.3690766%", x2: "45.4107524%", y2: "71.4898596%", id: gradientId },
                React.createElement("stop", { stopColor: "#00FF62", offset: "0%" }),
                React.createElement("stop", { stopColor: "#3197EF", stopOpacity: "0", offset: "100%" })),
            React.createElement("text", { className: s['letter'], fill: "url(#" + gradientId + ")", textAnchor: alignment, x: alignment === 'end' ? 15 : 0, y: "11" }, filteredTitle[0]))));
};
LiteratureCoverLetter.displayName = 'LiteratureCoverLetter';
export default LiteratureCoverLetter;
//# sourceMappingURL=LiteratureCoverLetter.js.map